function useGetVPNEnabled(_deviceId: string | undefined, _fleetId: string): false {
  return false;
}

export default useGetVPNEnabled;
